
import {
  Obra
} from '../index';


export class ObraStatusRegistro {
  "ObraId";
  "registro";
  "observacoes";
  "dataDeInicioDaIntegracao";
  "dataDeFimDaIntegracao";
  "integrado";
  "processodeIntegracaoCriado";
  "estaAptoAIntegracao";
  "equipe";
  "id";
  Obra;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraStatusRegistro`.
   */
  static getModelName() {
    return "ObraStatusRegistro";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraStatusRegistro for dynamic purposes.
  **/
  static factory(data) {
    return new ObraStatusRegistro(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraStatusRegistro',
      plural: 'ObraStatusRegistros',
      path: 'ObraStatusRegistros',
      properties: {
        "ObraId": {
          name: 'ObraId',
          type: 'string'
        },
        "registro": {
          name: 'registro',
          type: 'string'
        },
        "observacoes": {
          name: 'observacoes',
          type: 'string'
        },
        "dataDeInicioDaIntegracao": {
          name: 'dataDeInicioDaIntegracao',
          type: 'Date'
        },
        "dataDeFimDaIntegracao": {
          name: 'dataDeFimDaIntegracao',
          type: 'Date'
        },
        "integrado": {
          name: 'integrado',
          type: 'string'
        },
        "processodeIntegracaoCriado": {
          name: 'processodeIntegracaoCriado',
          type: 'boolean'
        },
        "estaAptoAIntegracao": {
          name: 'estaAptoAIntegracao',
          type: 'string'
        },
        "equipe": {
          name: 'equipe',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        Obra: {
          name: 'Obra',
          type: 'Obra',
          model: 'Obra'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraStatusRegistro.js